import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut, User } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const dashboardPath = user && user.role === "customer"
    ? "/customer"
    : user && user.role === "partner"
    ? "/partner"
    : user && user.role === "admin"
    ? "/admin"
    : "/";

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-border/40 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo-link">
          <div className="w-9 h-9 rounded-xl bg-[#1E3A8A] flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={2} />
          </div>
          <div>
            <div className="font-display font-black text-xl tracking-tight leading-none">Dhobi</div>
            <div className="text-[10px] text-muted-foreground tracking-wider uppercase font-semibold">Clean Connect</div>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          {user && typeof user === "object" ? (
            <>
              <Link
                to={dashboardPath}
                className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-foreground hover:bg-secondary transition-colors"
                data-testid="nav-dashboard-link"
              >
                <User className="w-4 h-4" /> {user.name}
              </Link>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-secondary hover:bg-secondary/70 transition-colors"
                data-testid="nav-logout-button"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-sm font-semibold px-4 py-2 rounded-lg hover:bg-secondary transition-colors"
                data-testid="nav-login-link"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="text-sm font-semibold px-5 py-2.5 rounded-lg bg-[#1E3A8A] text-white tactile-btn"
                data-testid="nav-signup-link"
              >
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
